import React from 'react';

const TestDuration = ({
  width = 16,
  height = 16,
  className,
  color,
  ...rest
}) => {
  return (
    <svg
      role="presentation"
      aria-hidden="true"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      {...rest}
    >
      <path
        d="M11.5 14.6654L12.9993 14.6654C13.353 14.6654 13.6921 14.5249 13.9422 14.2748C14.1922 14.0248 14.3327 13.6857 14.3327 13.332V4.9987L10.666 1.33203H4.99935C4.64573 1.33203 4.30659 1.47251 4.05654 1.72256C3.80649 1.9726 3.66602 2.31174 3.66602 2.66536V4.33203"
        stroke="#6E7781"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.334 1.33203V5.33203H14.334"
        stroke="#6E7781"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <g clip-path="url(#clip0_10009_134882)">
        <path
          d="M5.66706 8.29473V10.6651L7.08928 12.0873M5.66706 14.9318C3.31064 14.9318 1.40039 13.0215 1.40039 10.6651C1.40039 8.30869 3.31064 6.39844 5.66706 6.39844C8.02349 6.39844 9.93372 8.30869 9.93372 10.6651C9.93372 13.0215 8.02349 14.9318 5.66706 14.9318Z"
          stroke="#6E7781"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10009_134882">
          <rect
            width="10.6667"
            height="10.6667"
            fill="white"
            transform="translate(0.333984 5.33203)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export { TestDuration };
